import React, { useState } from 'react';
import { Button, Table } from 'antd';
import type { TableColumnsType, TableProps } from 'antd';
import TableInTable from './TableInTable';
import { mixGetV3 } from '../../../services/mixin';
import { useSelector } from 'react-redux';
import { selectorInfoUser } from '../../../store/slices/infoUserSlice';

type TableRowSelection<T extends object = object> = TableProps<T>['rowSelection'];

interface DataType {
  id: number
  type: number
  fullname: string
  birthday: string
  phoneNumber: string
  department: string
  namefile: string
  key: number;
  samePercent: string
}


const ImportDataStep5 = ({ stData = {} as any, onChange = (data = {}, type = null) => { } }) => {
  const user = useSelector(selectorInfoUser);
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [pageSize, setPageSize] = useState<number>(10)
  const [expandedRowKey, setExpandedRowKey] = useState<number | null>(null);
  const [currentTab, setCurrenttab] = useState<number>(4)
  const [currentStatus, setCurrentStatus] = useState<number>(-1)

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const SHOW_INFO_LABEL_MAP: Record<string, string> = {
    name: 'Tên khách hàng',
    customer_code: 'Mã khách hàng',
    id_card_no: 'CCCD/CMND',
    tel: 'Số điện thoại',
    address: 'Địa chỉ',
    birth_day: 'Ngày sinh',
    email: 'Email',
    gender_name: 'Giới tính',
    career: 'Nghề nghiệp',
    channels_name: 'Kênh',
    city: 'Thành phố',
    district: 'Quận/Huyện',
    contact_position: 'Chức vụ',
    cus_type_name: 'Loại khách hàng',
    id_tax: 'Mã số thuế',
  }

  const HIDDEN_FIELDS = ['status']

  const getShowInfo = (record: any) => {
    return record.show_info_cus || record.import_data?.show_info_cus || {}
  }

  const getShowInfoKeys = (): string[] => {
    const data = stData.step4Data?.data || []
    const keySet = new Set<string>()
    data.forEach((record: any) => {
      const showInfo = getShowInfo(record)
      Object.keys(showInfo).forEach((k: string) => {
        if (!HIDDEN_FIELDS.includes(k)) keySet.add(k)
      })
    })
    return Array.from(keySet)
  }

  const dynamicInfoColumns = getShowInfoKeys().map((field: string) => ({
    title: SHOW_INFO_LABEL_MAP[field] || field,
    dataIndex: field,
    ellipsis: true,
    render: (_: any, record: any) => {
      const showInfo = getShowInfo(record)
      const val = showInfo[field]
      const displayVal = val !== undefined && val !== null && val !== '' ? val : 'Không xác định'
      if (field === 'address') {
        return <div className='limit-text-address-step4-import' title={displayVal}>{displayVal}</div>
      }
      return displayVal
    },
  }))

  const columns = [
    {
      title: 'Trạng thái',
      dataIndex: 'type',
      render: (_: any, record: any) => {
        return (
          <div className='wrap-type-title'>
            {record.status === 'new' && <p className='first-element'>Mới</p>}
            {record.status === 'exist' && <p className='second-element'>Tồn tại</p>}
            {record.status === 'update' && <p className='second-element'>Cập nhật</p>}
          </div>
        )
      },
    },
    ...dynamicInfoColumns,
    {
      title: 'Hành động',
      dataIndex: 'action',
      render: (_: any, record: any) => {
        const isExpanded = expandedRowKey === record.idexist;
        return (
          record.status === 'update' && <Button
            type="link"
            onClick={() => {
              onChange({ expandedRowKey: stData.expandedRowKey === record.key ? null : record.key })
              if (!selectedRowKeys.includes(record.idexist)) {
                onSelectChange([...selectedRowKeys, record.idexist]);
              }
            }
            }
            className='cts-button-action'
          >
            {stData.expandedRowKey === record.key ? 'Rút gọn' : 'Xem chi tiết'}
          </Button>
        );
      },
    }
  ]

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    const curentListSelectStep4 = stData.listSelectStep4 || [] as any;
    newSelectedRowKeys.forEach((key) => {
      if (!curentListSelectStep4.includes(key)) {
        curentListSelectStep4.push(key);
      }
    });
    const unselectedIds = (stData.step4Data.data || [])
      .filter((item: any) => !newSelectedRowKeys.includes(item.idexist))
      .map((item: any) => item.idexist);

    const filteredList = curentListSelectStep4.filter((key: any) => !unselectedIds.includes(key));


    stData.step4Data.data.map((val: any, index: any) => {
      if (newSelectedRowKeys.includes(val.idexist)) {
        stData.step4DataSelected[val.idexist] = val
      } else {
        delete stData.step4DataSelected[val.idexist]
      }
    })


    onChange({ listSelectStep4: filteredList, step4DataSelected: stData.step4DataSelected }, null);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection: TableRowSelection<DataType> = {
    selectedRowKeys,
    onChange: onSelectChange
  };

  const getTaskResults = async (task_id: string, offset: any, limit: any, status = -1) => {
    let api = `/result/file_import_process/${task_id}?offset=${offset}&limit=${limit}`;
    if (status !== -1) {
      api += `&status_filter=${status}`;
    }
    const res = await mixGetV3(api, { admin_id: user.id }, { skipVehicleBrand: true });
    if (res && res.data) {
      const newSelectedRowKeys = res.data
        .filter((item: any) => stData.listSelectStep4.includes(item.idexist))
        .map((item: any) => item.idexist);
      setSelectedRowKeys(newSelectedRowKeys);
      res.data = res.data.map((item: any) => ({
        ...item,
        key: item.idexist,
      }));
      // Bảo toàn task_id/can_confirm của phiên khi response phân trang không trả lại các field này
      onChange({
        step4Data: {
          ...res,
          task_id: res.task_id || stData.step4Data?.task_id || task_id,
          can_confirm: res.can_confirm ?? stData.step4Data?.can_confirm,
        }
      });
    }
  };

  return (
    <>
      <h3 className='cts-h3-part-4'>Kiểm tra và xác nhận dữ liệu</h3>

      <div className="title-tab">
        <div className="tab-table">
          <div className={`tab-item ${currentTab === 4 && 'active'}`} onClick={() => {
            setCurrenttab(4)
            setCurrentStatus(-1)
            getTaskResults(stData.step4Data.task_id, 0, pageSize, -1)
            setCurrentPage(1)
          }}>
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_23148_474296)">
                <path d="M8 0.5C3.58214 0.5 0 4.08214 0 8.5C0 12.9179 3.58214 16.5 8 16.5C12.4179 16.5 16 12.9179 16 8.5C16 4.08214 12.4179 0.5 8 0.5ZM8 15.1429C4.33214 15.1429 1.35714 12.1679 1.35714 8.5C1.35714 4.83214 4.33214 1.85714 8 1.85714C11.6679 1.85714 14.6429 4.83214 14.6429 8.5C14.6429 12.1679 11.6679 15.1429 8 15.1429Z" fill="currentColor" />
                <path d="M7.14258 5.35714C7.14258 5.58447 7.23288 5.80249 7.39363 5.96323C7.55438 6.12398 7.77239 6.21429 7.99972 6.21429C8.22705 6.21429 8.44507 6.12398 8.60581 5.96323C8.76656 5.80249 8.85686 5.58447 8.85686 5.35714C8.85686 5.12981 8.76656 4.9118 8.60581 4.75105C8.44507 4.59031 8.22705 4.5 7.99972 4.5C7.77239 4.5 7.55438 4.59031 7.39363 4.75105C7.23288 4.9118 7.14258 5.12981 7.14258 5.35714ZM8.42829 7.35714H7.57115C7.49258 7.35714 7.42829 7.42143 7.42829 7.5V12.3571C7.42829 12.4357 7.49258 12.5 7.57115 12.5H8.42829C8.50686 12.5 8.57115 12.4357 8.57115 12.3571V7.5C8.57115 7.42143 8.50686 7.35714 8.42829 7.35714Z" fill="currentColor" />
              </g>
              <defs>
                <clipPath id="clip0_23148_474296">
                  <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
                </clipPath>
              </defs>
            </svg>
            <p>Tất cả</p>
            <label>{stData.step4Data.total_all_records}</label>
          </div>
          <div className={`tab-item ${currentTab === 1 && 'active'}`} onClick={() => {
            setCurrenttab(1)
            setCurrentStatus(0)
            getTaskResults(stData.step4Data.task_id, 0, pageSize, 0)
            setCurrentPage(1)
          }}>
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_22942_285499)">
                <path d="M11.3392 5.66016H10.5017C10.3196 5.66016 10.1464 5.74766 10.0392 5.89766L7.23209 9.79051L5.96066 8.02623C5.85352 7.87801 5.68209 7.78873 5.49816 7.78873H4.66066C4.54459 7.78873 4.47673 7.92087 4.54459 8.01551L6.76959 11.1012C6.82215 11.1746 6.89145 11.2344 6.97172 11.2756C7.052 11.3168 7.14095 11.3384 7.2312 11.3384C7.32145 11.3384 7.4104 11.3168 7.49067 11.2756C7.57095 11.2344 7.64024 11.1746 7.6928 11.1012L11.4535 5.88694C11.5232 5.7923 11.4553 5.66016 11.3392 5.66016Z" fill="currentColor" />
                <path d="M8 0.5C3.58214 0.5 0 4.08214 0 8.5C0 12.9179 3.58214 16.5 8 16.5C12.4179 16.5 16 12.9179 16 8.5C16 4.08214 12.4179 0.5 8 0.5ZM8 15.1429C4.33214 15.1429 1.35714 12.1679 1.35714 8.5C1.35714 4.83214 4.33214 1.85714 8 1.85714C11.6679 1.85714 14.6429 4.83214 14.6429 8.5C14.6429 12.1679 11.6679 15.1429 8 15.1429Z" fill="currentColor" />
              </g>
              <defs>
                <clipPath id="clip0_22942_285499">
                  <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
                </clipPath>
              </defs>
            </svg>
            <p>Mới</p>
            <label>{stData.step4Data.summary.total_new_records}</label>
          </div>

          <div className={`tab-item ${currentTab === 2 && 'active'}`} onClick={() => {
            setCurrenttab(2)
            setCurrentStatus(1)
            getTaskResults(stData.step4Data.task_id, 0, pageSize, 1)
            setCurrentPage(1)
          }}>
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_22942_285506)">
                <path d="M8 0.5C3.58214 0.5 0 4.08214 0 8.5C0 12.9179 3.58214 16.5 8 16.5C12.4179 16.5 16 12.9179 16 8.5C16 4.08214 12.4179 0.5 8 0.5ZM8 15.1429C4.33214 15.1429 1.35714 12.1679 1.35714 8.5C1.35714 4.83214 4.33214 1.85714 8 1.85714C11.6679 1.85714 14.6429 4.83214 14.6429 8.5C14.6429 12.1679 11.6679 15.1429 8 15.1429Z" fill="currentColor" />
                <path d="M7.14258 11.6429C7.14258 11.8702 7.23288 12.0882 7.39363 12.2489C7.55437 12.4097 7.77239 12.5 7.99972 12.5C8.22705 12.5 8.44507 12.4097 8.60581 12.2489C8.76656 12.0882 8.85686 11.8702 8.85686 11.6429C8.85686 11.4155 8.76656 11.1975 8.60581 11.0368C8.44507 10.876 8.22705 10.7857 7.99972 10.7857C7.77239 10.7857 7.55437 10.876 7.39363 11.0368C7.23288 11.1975 7.14258 11.4155 7.14258 11.6429ZM7.57115 9.64286H8.42829C8.50686 9.64286 8.57115 9.57857 8.57115 9.5V4.64286C8.57115 4.56429 8.50686 4.5 8.42829 4.5H7.57115C7.49258 4.5 7.42829 4.56429 7.42829 4.64286V9.5C7.42829 9.57857 7.49258 9.64286 7.57115 9.64286Z" fill="currentColor" />
              </g>
              <defs>
                <clipPath id="clip0_22942_285506">
                  <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
                </clipPath>
              </defs>
            </svg>
            <p>Tồn tại</p>
            <label>{stData.step4Data.summary.total_exist_records}</label>
          </div>

          <div className={`tab-item ${currentTab === 3 && 'active'}`} onClick={() => {
            setCurrenttab(3)
            setCurrentStatus(2)
            getTaskResults(stData.step4Data.task_id, 0, pageSize, 2)
            setCurrentPage(1)
          }}>
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_22942_285506)">
                <path d="M8 0.5C3.58214 0.5 0 4.08214 0 8.5C0 12.9179 3.58214 16.5 8 16.5C12.4179 16.5 16 12.9179 16 8.5C16 4.08214 12.4179 0.5 8 0.5ZM8 15.1429C4.33214 15.1429 1.35714 12.1679 1.35714 8.5C1.35714 4.83214 4.33214 1.85714 8 1.85714C11.6679 1.85714 14.6429 4.83214 14.6429 8.5C14.6429 12.1679 11.6679 15.1429 8 15.1429Z" fill="currentColor" />
                <path d="M7.14258 11.6429C7.14258 11.8702 7.23288 12.0882 7.39363 12.2489C7.55437 12.4097 7.77239 12.5 7.99972 12.5C8.22705 12.5 8.44507 12.4097 8.60581 12.2489C8.76656 12.0882 8.85686 11.8702 8.85686 11.6429C8.85686 11.4155 8.76656 11.1975 8.60581 11.0368C8.44507 10.876 8.22705 10.7857 7.99972 10.7857C7.77239 10.7857 7.55437 10.876 7.39363 11.0368C7.23288 11.1975 7.14258 11.4155 7.14258 11.6429ZM7.57115 9.64286H8.42829C8.50686 9.64286 8.57115 9.57857 8.57115 9.5V4.64286C8.57115 4.56429 8.50686 4.5 8.42829 4.5H7.57115C7.49258 4.5 7.42829 4.56429 7.42829 4.64286V9.5C7.42829 9.57857 7.49258 9.64286 7.57115 9.64286Z" fill="currentColor" />
              </g>
              <defs>
                <clipPath id="clip0_22942_285506">
                  <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
                </clipPath>
              </defs>
            </svg>
            <p>Cập nhật</p>
            <label>{stData.step4Data.summary.total_update_records}</label>
          </div>
        </div>

        <div className="analyze-info">Đã chọn <span>{stData.listSelectStep4.length}</span>/ <span>{stData.step4Data.summary.total_update_records}</span> bản ghi để import</div>
      </div>

      <div className="wrap-table">
        <div className="wrap-table">
          {stData.step4Data.data && stData.step4Data.data.length > 0 &&
            <Table
              scroll={{ x: 'max-content' }}
              className="cts-table none-go-to-page"
              rowSelection={{
                ...rowSelection,
                getCheckboxProps: (record: any) => ({
                  style: { display: record.status === 'update' ? undefined : 'none' },
                  disabled: record.status !== 'update',
                }),
              }}
              columns={columns}
              dataSource={stData.step4Data.data}
              tableLayout="auto"
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: stData.step4Data.total_records,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '15', '20', '50'],
                showQuickJumper: true,
                showTotal: (total, range) => `Tổng cộng ${Math.ceil(total / pageSize)} trang`,
                onChange: (page, size) => {
                  setCurrentPage(page);
                  setPageSize(size);
                  getTaskResults(stData.step4Data.task_id, (page - 1) * size, size, currentStatus);
                },
              }}
              expandable={{
                expandIcon: () => null,
                expandIconColumnIndex: -1,
                expandedRowRender: (record) => (
                  <div style={{ backgroundColor: '#ffffff' }}>
                    <TableInTable
                      recordParent={record}
                      stData={stData}
                      onChange={(data, type) => {
                        if (!type) {
                          onChange({ ...data });
                        }
                      }}
                    />
                  </div>
                ),
                expandedRowKeys: stData.expandedRowKey !== null ? [stData.expandedRowKey] : [],
                rowExpandable: (record: any) => record.idexist === stData.expandedRowKey,
                onExpand: (expanded, record: any) => {
                  onChange({ expandedRowKey: expanded ? record.idexist : null });
                },
              }}
            />
          }
        </div>
      </div>
    </>
  )
};

export default ImportDataStep5;
